import { Column } from 'react-table';
import VenueTypeCell from './venue-table-cells/venue-type-cell';
import { VenueTypeTypeOptions } from 'common/dto-types/venue-dto';
import { DateColumnFilter, SelectColumnFilter } from 'utils/react-table';
import DateTimeCell from 'pages/event-list-page/event-table-cells/date-time-cell';

const VenueTableColumnConfig: Column[] = [
    {
        Header: 'Id',
        accessor: 'id',
        disableSortBy: false,
    },
    {
        Header: 'Name',
        accessor: 'name',
        disableSortBy: false,
    },
    {
        Header: 'Created',
        accessor: 'created',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeCell,
    },
    {
        Header: 'Modified',
        accessor: 'modified',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeCell,
    },
    {
        Header: 'Time Zone',
        accessor: 'timeZone',
    },
    {
        Header: 'Venue Type',
        accessor: 'venueType',
        Cell: VenueTypeCell,
        Filter: (props) => <SelectColumnFilter {...props} options={VenueTypeTypeOptions} />,
    },
    {
        Header: 'Venue Type Id',
        accessor: 'venueTypeId',
    },
    {
        Header: 'Host City',
        id: 'hostCity',
        accessor: 'hostCity.name',
    },
    {
        Header: 'Address',
        accessor: 'address',
    },
    {
        Header: 'Address Line',
        accessor: 'addressLine',
    },
    {
        Header: 'City',
        accessor: 'city',
    },
    {
        Header: 'State',
        accessor: 'state',
    },
    {
        Header: 'Country',
        accessor: 'country',
    },
    {
        Header: 'Country Id',
        accessor: 'countryId',
    },
    {
        Header: 'Postal Code',
        accessor: 'postalCode',
    },
    {
        Header: 'Image URL',
        accessor: 'imageUrl',
    },
    {
        Header: 'Latitude',
        accessor: 'latitude',
    },
    {
        Header: 'Longitude',
        accessor: 'longitude',
    },
    {
        Header: 'Url',
        accessor: 'url',
    },
    {
        Header: 'Ifes Id',
        accessor: 'ifesId',
    },
];

export default VenueTableColumnConfig;

export const DefaultVisibleVenueColumns = ['name', 'venueType', 'city', 'country', 'ifesId'];

export const SearchableVenueTableColumnConfig = ['id', 'name', 'city', 'country', 'ifesId'];
